// Copyright (c) StrangeBee 2024

import { AdminPermissionsEnum, OrgPermissionsEnum, PermissionsEnum } from 'thehive-sdk';

export type PermissionExtract<T> = T extends (infer PermissionType)[]
    ? PermissionType extends `manage${infer Entity}/${infer RoleType}`
        ? `${RoleType}${Entity}`
        : PermissionType extends `manage${infer Entity}`
        ? Lowercase<Entity>
        : never
    : never;

export function useSplitPermissions<T extends PermissionsEnum[]>(
    permissionsToBeChecked: AdminPermissionsEnum[] | OrgPermissionsEnum[],
    permissions: T,
    externalCondition?: boolean,
): Record<PermissionExtract<T>, boolean> {
    return permissions.reduce((acc, permission) => {
        const [entity, role] = permission.split('/');

        return {
            ...acc,
            [role
                ? `${role}${entity.split(/(?=[A-Z])/)[1]}`
                : entity
                      .split(/(?=[A-Z])/)
                      .filter((_, index) => index !== 0)
                      .join('')
                      .toLocaleLowerCase()]:
                externalCondition !== undefined
                    ? externalCondition
                    : (permissionsToBeChecked as string[]).includes(permission),
        };
    }, {} as Record<PermissionExtract<T>, boolean>);
}
